export default {
  abuseUrl: 'https://24support.cc/api/v1/abuse/'
}
